import { Component, DestroyRef, inject, Input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'ez-iban-input',
  imports: [ReactiveFormsModule, NgxMaskDirective],
  templateUrl: './iban-input.component.html',
  styleUrl: './iban-input.component.scss',
})
export class IbanInputComponent implements OnInit, OnChanges {
  private rootFormGroup = inject(FormGroupDirective);
  private destroyRef = inject(DestroyRef);

  @Input() isDisabled = false;
  @Input() name: string;
  @Input() controlName: string;
  form: FormGroup;
  mask = 'UU00 AAAA AAAA AAAZ ZZZZ ZZZZ ZZZZ ZZZZ ZZ';

  readonly errorMessage = signal<string | null>(null);

  get control(): AbstractControl {
    return this.form.get(this.controlName)!;
  }

  private currentErrorMessage(): string | null {
    const control = this.control;
    if (!control.invalid || !(control.dirty || control.touched)) {
      return null;
    }
    if (control.errors?.['required']) {
      return 'Fehler: Dies ist ein Pflichtfeld.';
    }
    if (control.errors?.['iban']) {
      return 'Fehler: Die eingegebene IBAN ist fehlerhaft. Bitte überprüfen Sie Ihre Eingabe.';
    }
    return 'Fehlerhafte Eingabe.';
  }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control;
    this.control.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.errorMessage.set(this.currentErrorMessage()));
    this.updateDisabled();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isDisabled']) {
      this.updateDisabled();
    }
  }

  inputTransformFn = (value: unknown): string => {
    return typeof value === 'string' ? value.toUpperCase() : String(value);
  };

  outputTransformFn = (value: string | number | null | undefined): string => {
    return value ? String(value).toUpperCase() : '';
  };

  private updateDisabled(): void {
    const control = this.control;
    if (this.isDisabled) {
      control.disable();
    } else {
      control.enable();
    }
  }
}
